import React, { FC } from 'react'
import classNames from 'classnames'
import Sticky from 'react-stickynode'

import StylesModule from 'layout/top.module.scss'

import SEO from 'components/seo'
import DesignButton from 'components/lv1/designButton'
import ResponsiveImage from 'components/lv1/responsiveImage'
import ImageScrollButton from 'components/lv1/ImageScrollButton'
import AnimeArea from 'components/lv2/AnimeArea'
import ImageGrid from 'components/lv2/imageGrid'
import NumHeadlineTitle from 'components/lv2/NumHeadlineTitle'
import TopImage from 'components/lv3/topImage'
import TopOldImage from 'components/lv3/topOldImage'
import TopMessage from 'components/lv3/topMessage'

import Spa01Img from 'images/top/spa01.jpg'
import Spa02Img from 'images/top/spa02.jpg'
import Spa03Img from 'images/top/spa03.jpg'
import Room01Img from 'images/top/room01.jpg'
import Room02Img from 'images/top/room02.jpg'
import Room03Img from 'images/top/room03.jpg'
import Room04Img from 'images/top/room04.jpg'
import Kasuien01Img from 'images/top/kasuien01.jpg'
import Kasuien02Img from 'images/top/kasuien02.jpg'
import Kasuien03Img from 'images/top/kasuien03.jpg'
import Kasuien04Img from 'images/top/kasuien04.jpg'
import RestaurantDbk01Img from 'images/top/restaurant_dbk01.jpg'
import RestaurantDbk02Img from 'images/top/restaurant_dbk02.jpg'
import RestaurantLeteppanyaki01Img from 'images/top/restaurant_leteppanyaki01.jpg'
import RestaurantLeteppanyaki02Img from 'images/top/restaurant_leteppanyaki02.jpg'
import RestaurantRaqou01Img from 'images/top/restaurant_raqou01.jpg'
import RestaurantMayfair01Img from 'images/top/restaurant_mayfair01.jpg'
import RestaurantRokuza01Img from 'images/top/restaurant_rokuza01.jpg'
import RoofGarden01Img from 'images/top/roof_garden01.jpg'
import Tanchoro01Img from 'images/top/tanchoro01.jpg'
import Chapel01Img from 'images/top/chapel01.jpg'
import Banquet01Img from 'images/top/banquet01.jpg'

// Logo
import LogoKasuien from 'images/logo/kasuien.png'
import LogoRokuza from 'images/logo/rokuza.png'
import LogoDominiqueBouchetKyoto from 'images/logo/dominique-bouchet-kyoto.png'
import LogoLeTeppanyaki from 'images/logo/le-teppanyaki.png'
import LogoMayfair from 'images/logo/mayfair.png'
import LogoRaqou from 'images/logo/raqou.png'

import { MessageProps } from 'message/index.props'
export interface TopPageProps {
  message: MessageProps
  lang: string
}

const TopPage: FC<TopPageProps> = ({ message, lang }) => {
  return (
    <section className={classNames(StylesModule.top)}>
      <SEO title={message.top.page_title} lang={lang} />
      <div id="top">
        <TopImage message={message} lang={lang} />
        <TopOldImage />
      </div>
      <section
        id="message"
        className={classNames(StylesModule.top__bgMessage, 'hr-border-top')}
      >
        <TopMessage message={message} />
        <Sticky
          top="#top"
          bottomBoundary="#other"
          innerZ="10"
          className={StylesModule.top__topScrollButtonSticky}
          activeClass={StylesModule.top__topScrollButtonActive}
          releasedClass={StylesModule.top__topScrollButtonReleased}
          innerClass={StylesModule.top__topScrollButtonInner}
        >
          <div className={classNames(StylesModule.top__topScrollButton)}>
            <ImageScrollButton target="top" text="TOPへ" />
          </div>
        </Sticky>
      </section>

      {/* 1 */}
      <section
        id="spa"
        className={classNames(
          StylesModule.top__bgA,
          'hr-border-top',
          'pt-64',
          'pt-tb-80',
          'pb-64',
          'pb-tb-80',
        )}
      >
        {/* SPA */}
        <AnimeArea>
          <NumHeadlineTitle
            num={message.top.spa.section_title.num}
            headline={message.top.spa.section_title.headline}
            title={message.top.spa.section_title.title}
          />
        </AnimeArea>
        <div className="mt-48 mt-tb-64">
          <ImageGrid addClassName="triangle">
            <ResponsiveImage
              imageSrc={Spa01Img}
              imageAlt=""
              aspect={{
                mb: { x: 343, y: 191 },
                tb: { x: 672, y: 183 },
                pc: { x: 844, y: 276 },
              }}
            />
            <ResponsiveImage
              imageSrc={Spa02Img}
              imageAlt=""
              aspect={{
                mb: { x: 343, y: 191 },
                tb: { x: 328, y: 183 },
                pc: { x: 414, y: 276 },
              }}
            />
            <ResponsiveImage
              imageSrc={Spa03Img}
              imageAlt=""
              aspect={{
                mb: { x: 343, y: 191 },
                tb: { x: 328, y: 183 },
                pc: { x: 414, y: 276 },
              }}
            />
          </ImageGrid>
        </div>
        <div
          className={classNames(
            StylesModule.topTitleTextButton,
            'mt-24',
            'mt-tb-40',
          )}
        >
          <AnimeArea>
            <h1
              className={classNames(StylesModule.topTitleTextButton__title)}
              dangerouslySetInnerHTML={{
                __html: message.top.spa.contents[0].title,
              }}
            />
          </AnimeArea>
          <AnimeArea>
            <div
              className={classNames(StylesModule.topTitleTextButton__text)}
              dangerouslySetInnerHTML={{
                __html: message.top.spa.contents[0].text,
              }}
            />
            <div
              className={classNames(StylesModule.topTitleTextButton__button)}
            >
              <DesignButton
                label={message.global.detail}
                to={message.top.spa.contents[0].button.url}
                design="top-fill"
              />
            </div>
          </AnimeArea>
        </div>
      </section>
      {/* 2 */}
      <section id="room" className="pt-64 pt-tb-80">
        {/* 客室 */}
        <AnimeArea>
          <NumHeadlineTitle
            num={message.top.room.section_title.num}
            headline={message.top.room.section_title.headline}
            title={message.top.room.section_title.title}
          />
        </AnimeArea>
        {/* 客室-1 */}
        <div className="mt-48 mt-tb-64">
          <ImageGrid addClassName="col2">
            <ResponsiveImage
              imageSrc={Room01Img}
              imageAlt=""
              aspect={{
                mb: { x: 343, y: 191 },
                tb: { x: 328, y: 183 },
                pc: { x: 414, y: 276 },
              }}
            />
            <ResponsiveImage
              imageSrc={Room02Img}
              imageAlt=""
              aspect={{
                mb: { x: 343, y: 191 },
                tb: { x: 328, y: 183 },
                pc: { x: 414, y: 276 },
              }}
            />
          </ImageGrid>
        </div>
        <div
          className={classNames(
            StylesModule.topTitleTextButton,
            'mt-40',
            'mt-tb-48',
          )}
        >
          <AnimeArea>
            <h1
              className={classNames(StylesModule.topTitleTextButton__title)}
              dangerouslySetInnerHTML={{
                __html: message.top.room.contents[0].title,
              }}
            />
          </AnimeArea>
          <AnimeArea>
            <div
              className={classNames(StylesModule.topTitleTextButton__text)}
              dangerouslySetInnerHTML={{
                __html: message.top.room.contents[0].text,
              }}
            />
            <div
              className={classNames(StylesModule.topTitleTextButton__button)}
            >
              <DesignButton
                label={message.global.detail}
                to={message.top.room.contents[0].button.url}
                design="top-fill"
              />
            </div>
          </AnimeArea>
        </div>
        {/* 客室-2 */}
        <div
          className={classNames(
            StylesModule.topImageTitleTextButton,
            StylesModule.topImageTitleTextButtonLeft,
            'mt-48',
            'mt-tb-64',
          )}
        >
          <div
            className={classNames(StylesModule.topImageTitleTextButton__image)}
          >
            <ResponsiveImage
              imageSrc={Room03Img}
              imageAlt=""
              aspect={{
                mb: { x: 343, y: 191 },
                tb: { x: 328, y: 183 },
                pc: { x: 414, y: 276 },
              }}
            />
          </div>
          <div
            className={classNames(
              StylesModule.topTitleTextButton,
              'mt-40',
              'mt-tb-0',
            )}
          >
            <AnimeArea>
              <h1
                className={classNames(StylesModule.topTitleTextButton__title)}
                dangerouslySetInnerHTML={{
                  __html: message.top.room.contents[1].title,
                }}
              />
            </AnimeArea>
            <AnimeArea>
              <div
                className={classNames(StylesModule.topTitleTextButton__text)}
                dangerouslySetInnerHTML={{
                  __html: message.top.room.contents[1].text,
                }}
              />
              <div
                className={classNames(StylesModule.topTitleTextButton__button)}
              >
                <DesignButton
                  label={message.global.detail}
                  to={message.top.room.contents[1].button.url}
                  design="top-fill"
                />
              </div>
            </AnimeArea>
          </div>
        </div>
        {/* 客室-3 */}
        <div
          className={classNames(
            StylesModule.topImageTitleTextButton,
            StylesModule.topImageTitleTextButtonRight,
            'mt-48',
            'mt-tb-64',
          )}
        >
          <div
            className={classNames(StylesModule.topImageTitleTextButton__image)}
          >
            <ResponsiveImage
              imageSrc={Room04Img}
              imageAlt=""
              aspect={{
                mb: { x: 343, y: 191 },
                tb: { x: 328, y: 183 },
                pc: { x: 414, y: 276 },
              }}
            />
          </div>
          <div
            className={classNames(
              StylesModule.topTitleTextButton,
              'mt-40',
              'mt-tb-0',
            )}
          >
            <AnimeArea>
              <h1
                className={classNames(StylesModule.topTitleTextButton__title)}
                dangerouslySetInnerHTML={{
                  __html: message.top.room.contents[2].title,
                }}
              />
            </AnimeArea>
            <AnimeArea>
              <div
                className={classNames(StylesModule.topTitleTextButton__text)}
                dangerouslySetInnerHTML={{
                  __html: message.top.room.contents[2].text,
                }}
              />
              <div
                className={classNames(StylesModule.topTitleTextButton__button)}
              >
                <DesignButton
                  label={message.global.detail}
                  to={message.top.room.contents[2].button.url}
                  design="top-fill"
                />
              </div>
            </AnimeArea>
          </div>
        </div>
      </section>
      {/* 3 */}
      <section
        id="kasuien"
        className={classNames(
          StylesModule.top__bgA,
          'mt-64',
          'mt-tb-80',
          'pt-64',
          'pt-tb-80',
          'pb-64',
          'pb-tb-80',
        )}
      >
        {/* 佳水園 */}
        <AnimeArea>
          <NumHeadlineTitle
            num={message.top.kasuien.section_title.num}
            headline={message.top.kasuien.section_title.headline}
            title={message.top.kasuien.section_title.title}
          />
        </AnimeArea>
        <div className="mt-48 mt-tb-64">
          <ImageGrid addClassName="col2">
            <ResponsiveImage
              imageSrc={Kasuien01Img}
              imageAlt=""
              aspect={{
                mb: { x: 343, y: 191 },
                tb: { x: 328, y: 183 },
                pc: { x: 414, y: 276 },
              }}
            />
            <ResponsiveImage
              imageSrc={Kasuien02Img}
              imageAlt=""
              aspect={{
                mb: { x: 343, y: 191 },
                tb: { x: 328, y: 183 },
                pc: { x: 414, y: 276 },
              }}
            />
            <ResponsiveImage
              imageSrc={Kasuien03Img}
              imageAlt=""
              aspect={{
                mb: { x: 343, y: 191 },
                tb: { x: 328, y: 183 },
                pc: { x: 414, y: 276 },
              }}
            />
            <ResponsiveImage
              imageSrc={Kasuien04Img}
              imageAlt=""
              aspect={{
                mb: { x: 343, y: 191 },
                tb: { x: 328, y: 183 },
                pc: { x: 414, y: 276 },
              }}
            />
          </ImageGrid>
        </div>
        <div
          className={classNames(
            StylesModule.topTitleTextButton,
            'mt-24',
            'mt-tb-40',
          )}
        >
          <AnimeArea>
            <h1
              className={classNames(StylesModule.topTitleTextButton__title)}
              dangerouslySetInnerHTML={{
                __html: message.top.kasuien.contents[0].title,
              }}
            />
          </AnimeArea>
          <AnimeArea>
            <div
              className={classNames(StylesModule.topTitleTextButton__text)}
              dangerouslySetInnerHTML={{
                __html: message.top.kasuien.contents[0].text,
              }}
            />
            <div
              className={classNames(
                StylesModule.topTitleTextButton__button,
                StylesModule.topTitleTextButton__buttonLogo,
              )}
            >
              <DesignButton
                label={message.global.detail}
                to={message.top.kasuien.contents[0].button.url}
                design="top-fill"
              />
              <div
                className={classNames(StylesModule.topTitleTextButton__logo)}
              >
                <img src={LogoKasuien} area-hidden="true" alt="" />
              </div>
            </div>
          </AnimeArea>
        </div>
      </section>
      {/* 4 */}
      <section id="restaurant" className="pt-64 pt-tb-80">
        {/* レストラン */}
        <AnimeArea>
          <NumHeadlineTitle
            num={message.top.restaurant.section_title.num}
            headline={message.top.restaurant.section_title.headline}
            title={message.top.restaurant.section_title.title}
          />
        </AnimeArea>
        {/* レストラン-1 */}
        <div className="mt-32 mt-tb-40">
          <ImageGrid addClassName="col2">
            <ResponsiveImage
              imageSrc={RestaurantDbk01Img}
              imageAlt=""
              aspect={{
                mb: { x: 343, y: 191 },
                tb: { x: 328, y: 183 },
                pc: { x: 414, y: 276 },
              }}
            />
            <ResponsiveImage
              imageSrc={RestaurantDbk02Img}
              imageAlt=""
              aspect={{
                mb: { x: 343, y: 191 },
                tb: { x: 328, y: 183 },
                pc: { x: 414, y: 276 },
              }}
            />
          </ImageGrid>
        </div>
        <div
          className={classNames(
            StylesModule.topTitleTextButton,
            'mt-24',
            'mt-tb-40',
          )}
        >
          <AnimeArea>
            <h1
              className={classNames(StylesModule.topTitleTextButton__title)}
              dangerouslySetInnerHTML={{
                __html: message.top.restaurant.contents[0].title,
              }}
            />
          </AnimeArea>
          <AnimeArea>
            <div
              className={classNames(StylesModule.topTitleTextButton__text)}
              dangerouslySetInnerHTML={{
                __html: message.top.restaurant.contents[0].text,
              }}
            />
            <div
              className={classNames(
                StylesModule.topTitleTextButton__button,
                StylesModule.topTitleTextButton__buttonLogo,
              )}
            >
              <DesignButton
                label={message.global.detail}
                to={message.top.restaurant.contents[0].button.url}
                design="top-fill"
              />
              <div
                className={classNames(StylesModule.topTitleTextButton__logo)}
              >
                <img
                  src={LogoDominiqueBouchetKyoto}
                  area-hidden="true"
                  alt=""
                />
              </div>
            </div>
          </AnimeArea>
        </div>
        {/* レストラン-2 */}
        <div className="mt-48 mt-tb-64">
          <ImageGrid addClassName="col2">
            <ResponsiveImage
              imageSrc={RestaurantLeteppanyaki01Img}
              imageAlt=""
              aspect={{
                mb: { x: 343, y: 191 },
                tb: { x: 328, y: 183 },
                pc: { x: 414, y: 276 },
              }}
            />
            <ResponsiveImage
              imageSrc={RestaurantLeteppanyaki02Img}
              imageAlt=""
              aspect={{
                mb: { x: 343, y: 191 },
                tb: { x: 328, y: 183 },
                pc: { x: 414, y: 276 },
              }}
            />
          </ImageGrid>
        </div>
        <div
          className={classNames(
            StylesModule.topTitleTextButton,
            'mt-24',
            'mt-tb-40',
          )}
        >
          <AnimeArea>
            <h1
              className={classNames(StylesModule.topTitleTextButton__title)}
              dangerouslySetInnerHTML={{
                __html: message.top.restaurant.contents[1].title,
              }}
            />
          </AnimeArea>
          <AnimeArea>
            <div
              className={classNames(StylesModule.topTitleTextButton__text)}
              dangerouslySetInnerHTML={{
                __html: message.top.restaurant.contents[1].text,
              }}
            />
            <div
              className={classNames(
                StylesModule.topTitleTextButton__button,
                StylesModule.topTitleTextButton__buttonLogo,
              )}
            >
              <DesignButton
                label={message.global.detail}
                to={message.top.restaurant.contents[1].button.url}
                design="top-fill"
              />
              <div
                className={classNames(StylesModule.topTitleTextButton__logo)}
              >
                <img src={LogoLeTeppanyaki} area-hidden="true" alt="" />
              </div>
            </div>
          </AnimeArea>
        </div>
        {/* レストラン-3 */}
        <div className="mt-48 mt-tb-64">
          <ImageGrid addClassName="triangle">
            <ResponsiveImage
              imageSrc={RestaurantRaqou01Img}
              imageAlt=""
              aspect={{
                mb: { x: 343, y: 191 },
                tb: { x: 672, y: 183 },
                pc: { x: 844, y: 276 },
              }}
            />
          </ImageGrid>
        </div>
        <div
          className={classNames(
            StylesModule.topTitleTextButton,
            'mt-24',
            'mt-tb-40',
          )}
        >
          <AnimeArea>
            <h1
              className={classNames(StylesModule.topTitleTextButton__title)}
              dangerouslySetInnerHTML={{
                __html: message.top.restaurant.contents[2].title,
              }}
            />
          </AnimeArea>
          <AnimeArea>
            <div
              className={classNames(StylesModule.topTitleTextButton__text)}
              dangerouslySetInnerHTML={{
                __html: message.top.restaurant.contents[2].text,
              }}
            />
            <div
              className={classNames(
                StylesModule.topTitleTextButton__button,
                StylesModule.topTitleTextButton__buttonLogo,
              )}
            >
              <DesignButton
                label={message.global.detail}
                to={message.top.restaurant.contents[2].button.url}
                design="top-fill"
              />
              <div
                className={classNames(StylesModule.topTitleTextButton__logo)}
              >
                <img src={LogoRaqou} area-hidden="true" alt="" />
              </div>
            </div>
          </AnimeArea>
        </div>
        {/* レストラン-4 */}
        <div className="mt-48 mt-tb-64">
          <ImageGrid addClassName="triangle">
            <ResponsiveImage
              imageSrc={RestaurantMayfair01Img}
              imageAlt=""
              aspect={{
                mb: { x: 343, y: 191 },
                tb: { x: 672, y: 183 },
                pc: { x: 844, y: 276 },
              }}
            />
          </ImageGrid>
        </div>
        <div
          className={classNames(
            StylesModule.topTitleTextButton,
            'mt-24',
            'mt-tb-40',
          )}
        >
          <AnimeArea>
            <h1
              className={classNames(StylesModule.topTitleTextButton__title)}
              dangerouslySetInnerHTML={{
                __html: message.top.restaurant.contents[3].title,
              }}
            />
            <div
              className={classNames(StylesModule.topTitleTextButton__text)}
              dangerouslySetInnerHTML={{
                __html: message.top.restaurant.contents[3].text,
              }}
            />
            <div
              className={classNames(
                StylesModule.topTitleTextButton__button,
                StylesModule.topTitleTextButton__buttonLogo,
              )}
            >
              <DesignButton
                label={message.global.detail}
                to={message.top.restaurant.contents[3].button.url}
                design="top-fill"
              />
              <div
                className={classNames(StylesModule.topTitleTextButton__logo)}
              >
                <img src={LogoMayfair} area-hidden="true" alt="" />
              </div>
            </div>
          </AnimeArea>
        </div>
        {/* レストラン-5 */}
        <div className="mt-48 mt-tb-64">
          <ImageGrid addClassName="triangle">
            <ResponsiveImage
              imageSrc={RestaurantRokuza01Img}
              imageAlt=""
              aspect={{
                mb: { x: 343, y: 191 },
                tb: { x: 672, y: 183 },
                pc: { x: 844, y: 276 },
              }}
            />
          </ImageGrid>
        </div>
        <div
          className={classNames(
            StylesModule.topTitleTextButton,
            'mt-24',
            'mt-tb-40',
          )}
        >
          <AnimeArea>
            <h1
              className={classNames(StylesModule.topTitleTextButton__title)}
              dangerouslySetInnerHTML={{
                __html: message.top.restaurant.contents[4].title,
              }}
            />
          </AnimeArea>
          <AnimeArea>
            <div
              className={classNames(StylesModule.topTitleTextButton__text)}
              dangerouslySetInnerHTML={{
                __html: message.top.restaurant.contents[4].text,
              }}
            />
            <div
              className={classNames(
                StylesModule.topTitleTextButton__button,
                StylesModule.topTitleTextButton__buttonLogo,
              )}
            >
              <DesignButton
                label={message.global.detail}
                to={message.top.restaurant.contents[4].button.url}
                design="top-fill"
              />
              <div
                className={classNames(StylesModule.topTitleTextButton__logo)}
              >
                <img src={LogoRokuza} area-hidden="true" alt="" />
              </div>
            </div>
          </AnimeArea>
        </div>
      </section>

      <div id="other" className={classNames('pb-32', 'pb-tb-64')}>
        <div
          className={classNames(
            StylesModule.top__bgA,
            'hr-border-top',
            'mt-64',
            'mt-tb-80',
            'pt-64',
            'pt-tb-80',
            'pb-64',
            'pb-tb-80',
          )}
        >
          {/* 5 */}
          <section>
            {/* 屋上庭園 */}
            <AnimeArea>
              <NumHeadlineTitle
                num={message.top.roof_garden.section_title.num}
                headline={message.top.roof_garden.section_title.headline}
                title={message.top.roof_garden.section_title.title}
              />
            </AnimeArea>
            {/* 5-1 */}
            <div
              className={classNames(
                StylesModule.topImageTitleTextButton,
                StylesModule.topImageTitleTextButtonLeft,
                'mt-48',
                'mt-tb-64',
              )}
            >
              <div
                className={classNames(
                  StylesModule.topImageTitleTextButton__image,
                )}
              >
                <ResponsiveImage
                  imageSrc={RoofGarden01Img}
                  imageAlt=""
                  aspect={{
                    mb: { x: 343, y: 191 },
                    tb: { x: 328, y: 183 },
                    pc: { x: 414, y: 276 },
                  }}
                />
              </div>
              <div
                className={classNames(
                  StylesModule.topTitleTextButton,
                  'mt-40',
                  'mt-tb-0',
                )}
              >
                <AnimeArea>
                  <h1
                    className={classNames(
                      StylesModule.topTitleTextButton__title,
                    )}
                    dangerouslySetInnerHTML={{
                      __html: message.top.roof_garden.contents[0].title,
                    }}
                  />
                </AnimeArea>
                <AnimeArea>
                  <div
                    className={classNames(
                      StylesModule.topTitleTextButton__text,
                    )}
                    dangerouslySetInnerHTML={{
                      __html: message.top.roof_garden.contents[0].text,
                    }}
                  />
                </AnimeArea>
              </div>
            </div>
          </section>
          {/* 6 */}
          <section className={classNames('mt-64')}>
            {/* 探鳥路 */}
            <AnimeArea>
              <NumHeadlineTitle
                num={message.top.tanchoro.section_title.num}
                headline={message.top.tanchoro.section_title.headline}
                title={message.top.tanchoro.section_title.title}
              />
            </AnimeArea>
            <div
              className={classNames(
                StylesModule.topImageTitleTextButton,
                StylesModule.topImageTitleTextButtonRight,
                'mt-48',
                'mt-tb-64',
              )}
            >
              <div
                className={classNames(
                  StylesModule.topImageTitleTextButton__image,
                )}
              >
                <ResponsiveImage
                  imageSrc={Tanchoro01Img}
                  imageAlt=""
                  aspect={{
                    mb: { x: 343, y: 191 },
                    tb: { x: 328, y: 183 },
                    pc: { x: 414, y: 276 },
                  }}
                />
              </div>
              <div
                className={classNames(
                  StylesModule.topTitleTextButton,
                  'mt-40',
                  'mt-tb-0',
                )}
              >
                <AnimeArea>
                  <h1
                    className={classNames(
                      StylesModule.topTitleTextButton__title,
                    )}
                    dangerouslySetInnerHTML={{
                      __html: message.top.tanchoro.contents[0].title,
                    }}
                  />
                </AnimeArea>
                <AnimeArea>
                  <div
                    className={classNames(
                      StylesModule.topTitleTextButton__text,
                    )}
                    dangerouslySetInnerHTML={{
                      __html: message.top.tanchoro.contents[0].text,
                    }}
                  />
                </AnimeArea>
              </div>
            </div>
          </section>
          {/* 7 */}
          <section className={classNames('mt-64')}>
            {/* チャペル */}
            <AnimeArea>
              <NumHeadlineTitle
                num={message.top.chapel.section_title.num}
                headline={message.top.chapel.section_title.headline}
                title={message.top.chapel.section_title.title}
              />
            </AnimeArea>
            <div
              className={classNames(
                StylesModule.topImageTitleTextButton,
                StylesModule.topImageTitleTextButtonLeft,
                'mt-48',
                'mt-tb-64',
              )}
            >
              <div
                className={classNames(
                  StylesModule.topImageTitleTextButton__image,
                )}
              >
                <ResponsiveImage
                  imageSrc={Chapel01Img}
                  imageAlt=""
                  aspect={{
                    mb: { x: 343, y: 191 },
                    tb: { x: 328, y: 183 },
                    pc: { x: 414, y: 276 },
                  }}
                />
              </div>
              <div
                className={classNames(
                  StylesModule.topTitleTextButton,
                  'mt-40',
                  'mt-tb-0',
                )}
              >
                <AnimeArea>
                  <h1
                    className={classNames(
                      StylesModule.topTitleTextButton__title,
                    )}
                    dangerouslySetInnerHTML={{
                      __html: message.top.chapel.contents[0].title,
                    }}
                  />
                </AnimeArea>
                <AnimeArea>
                  <div
                    className={classNames(
                      StylesModule.topTitleTextButton__text,
                    )}
                    dangerouslySetInnerHTML={{
                      __html: message.top.chapel.contents[0].text,
                    }}
                  />
                  <div
                    className={classNames(
                      StylesModule.topTitleTextButton__button,
                    )}
                  >
                    <DesignButton
                      label={message.global.detail}
                      to={message.top.chapel.contents[0].button.url}
                      design="top-fill"
                    />
                  </div>
                </AnimeArea>
              </div>
            </div>
          </section>
          {/* 8 */}
          <section className={classNames('mt-64')}>
            {/* バンケット */}
            <AnimeArea>
              <NumHeadlineTitle
                num={message.top.banquet.section_title.num}
                headline={message.top.banquet.section_title.headline}
                title={message.top.banquet.section_title.title}
              />
            </AnimeArea>
            <div
              className={classNames(
                StylesModule.topImageTitleTextButton,
                StylesModule.topImageTitleTextButtonRight,
                'mt-48',
                'mt-tb-64',
              )}
            >
              <div
                className={classNames(
                  StylesModule.topImageTitleTextButton__image,
                )}
              >
                <ResponsiveImage
                  imageSrc={Banquet01Img}
                  imageAlt=""
                  aspect={{
                    mb: { x: 343, y: 191 },
                    tb: { x: 328, y: 183 },
                    pc: { x: 414, y: 276 },
                  }}
                />
              </div>
              <div
                className={classNames(
                  StylesModule.topTitleTextButton,
                  'mt-40',
                  'mt-tb-0',
                )}
              >
                <AnimeArea>
                  <h1
                    className={classNames(
                      StylesModule.topTitleTextButton__title,
                    )}
                    dangerouslySetInnerHTML={{
                      __html: message.top.banquet.contents[0].title,
                    }}
                  />
                </AnimeArea>
                <AnimeArea>
                  <div
                    className={classNames(
                      StylesModule.topTitleTextButton__text,
                    )}
                    dangerouslySetInnerHTML={{
                      __html: message.top.banquet.contents[0].text,
                    }}
                  />
                </AnimeArea>
              </div>
            </div>
          </section>
        </div>
      </div>
    </section>
  )
}

export default TopPage
